import React from 'react';
import "./table-loader.scss";

const TableLoader = () => {

    return (
        <div className="table_shimmer">
        <div className="shimmer_box">
          <div className="box_insidead">
            <div className="table_head_shimmer">
              <div className="info_title">
                <div className="box_content contents">
                  <div className="text text_l">
                    <span className="visual"></span>
                  </div>
                  <div className="text text_m">
                    <span className="visual"></span>
                  </div>
                  <div className="text text_m">
                    <span className="visual"></span>
                  </div>
                </div>
              </div>
              <div className="info_title_bg">
                <div className="box_content contents">
                  <div className="text text_l">
                    <span className="visual"></span>
                  </div>
                  <div className="text text_m">
                    <span className="visual"></span>
                  </div>
                </div>
              </div>

              <div class="b2b-lib-dataTable">
                <div class="sr_table">
                  <table>
                    <thead>
                      <tr className="table_shimmer_loader ">
                        <th>
                          <div class="text">
                            <span class="visual">Location ID</span>
                          </div>
                        </th>
                        <th>
                          <div class="text">
                            <span class="visual">Company Name</span>
                          </div>
                        </th>
                        <th>
                          <div class="text">
                            <span class="visual">Bandwidth</span>
                          </div>
                        </th>
                        <th>
                          <div class="text">
                            <span class="visual">Pincode</span>
                          </div>
                        </th>
                        <th>
                          <div class="text">
                            <span class="visual">Installation Address</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="table_shimmer_loader">
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text text_m">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                      </tr>
                      <tr class="table_shimmer_loader">
                        <td>
                          <div class="text">
                            <span class="visual text_l"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text text_m">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                      </tr>
                      <tr class="table_shimmer_loader">
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                      </tr>
                      <tr class="table_shimmer_loader">
                        <td>
                          <div class="text text_l">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text text_l">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text text_l">
                            <span class="visual"></span>
                          </div>
                        </td>
                      </tr>
                      <tr class="table_shimmer_loader">
                        <td>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                          <div class="text text_s">
                            <span class="visual"></span>
                          </div>
                        </td>
                        <td>
                          <div class="text">
                            <span class="visual"></span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
        </div>
      </div>
      </div>
    
    )
}


export default TableLoader